import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'app';

  constructor(private http: HttpClient) {

  }

  async ngOnInit(): Promise<void> {
    
  }

  ngAfterViewInit(): void {
    // The shared TDOE header renders a duplicate app image link even when no
    // real app icon is supplied. Remove that duplicate from the DOM locally.
    queueMicrotask(() => {
      const logoLink = document.querySelector('tdoe-header img.logo')?.closest('a');
      const logoImage = logoLink?.querySelector('img.logo');

      logoLink?.setAttribute('aria-label', 'Tennessee Course Catalog home');
      logoImage?.setAttribute('alt', '');
      logoImage?.setAttribute('role', 'presentation');
      logoImage?.setAttribute('aria-hidden', 'true');

      document.querySelector('tdoe-header img.app')?.closest('a')?.remove();
    });
  }

}
